<script setup lang="ts">
defineProps<{
  element?: string | Component
}>()
</script>

<template>
  <component
    :is="element || 'div'"
    class="content-wrapper"
  >
    <slot />
  </component>
</template>
